import * as actionTypes from '../types/configurator';

// get attribs by operation
export function getConfigureStockAttributes(payload) {
  return {
    type: actionTypes.GET_SKU_ATTRIBUTES,
    payload
  };
}
export function getConfigureStockAttributesSuccess(payload) {
  return {
    type: actionTypes.GET_SKU_ATTRIBUTES_SUCCESS,
    payload
  };
}
export function getConfigureStockAttributesFail(payload) {
  return {
    type: actionTypes.GET_SKU_ATTRIBUTES_FAIL,
    payload
  };
}

// get attribs by operation
export function getAllAttributes(payload) {
  return {
    type: actionTypes.GET_ALL_ATTRIBUTES,
    payload
  };
}
export function getAllAttributesSuccess(payload) {
  return {
    type: actionTypes.GET_ALL_ATTRIBUTES_SUCCESS,
    payload
  };
}
export function getAllAttributesFail(payload) {
  return {
    type: actionTypes.GET_ALL_ATTRIBUTES_FAIL,
    payload
  };
}
// get attribs dictionary
export function getInheritTypes(payload) {
  return {
    type: actionTypes.GET_INHERIT_TYPES,
    payload
  };
}
export function getInheritTypesSuccess(payload) {
  return {
    type: actionTypes.GET_INHERIT_TYPES_SUCCESS,
    payload
  };
}
export function getInheritTypesFail(payload) {
  return {
    type: actionTypes.GET_INHERIT_TYPES_FAIL,
    payload
  };
}

// save attributes TODO: реализация зависит от бекенда
export function saveConfigureStockAttributes(payload) {
  return {
    type: actionTypes.SAVE_SKU_ATTRIBUTES,
    payload
  };
}
export function saveConfigureStockAttributesSuccess(payload) {
  return {
    type: actionTypes.SAVE_SKU_ATTRIBUTES_SUCCESS,
    payload
  };
}
export function saveConfigureStockAttributesFail(payload) {
  return {
    type: actionTypes.SAVE_SKU_ATTRIBUTES_FAIL,
    payload
  };
}
// get operations
export function getAvailableOperations(payload) {
  return {
    type: actionTypes.GET_AVAILABLE_OPERATIONS,
    payload
  };
}
export function getAvailableOperationsSuccess(payload) {
  return {
    type: actionTypes.GET_AVAILABLE_OPERATIONS_SUCCESS,
    payload
  };
}
export function getAvailableOperationsFail(payload) {
  return {
    type: actionTypes.GET_AVAILABLE_OPERATIONS_FAIL,
    payload
  };
}
// get all operations for configure
export function getAllOperations(payload) {
  return {
    type: actionTypes.GET_ALL_OPERATIONS,
    payload
  };
}
export function getAllOperationsSuccess(payload) {
  return {
    type: actionTypes.GET_ALL_OPERATIONS_SUCCESS,
    payload
  };
}
export function getAllOperationsFail(payload) {
  return {
    type: actionTypes.GET_ALL_OPERATIONS_FAIL,
    payload
  };
}
// save operations
export function saveAvailableOperations(payload) {
  return {
    type: actionTypes.SAVE_AVAILABLE_OPERATIONS,
    payload
  };
}
export function saveAvailableOperationsSuccess(payload) {
  return {
    type: actionTypes.SAVE_AVAILABLE_OPERATIONS_SUCCESS,
    payload
  };
}
export function saveAvailableOperationsFail(payload) {
  return {
    type: actionTypes.SAVE_AVAILABLE_OPERATIONS_FAIL,
    payload
  };
}
// create new operation

export function createOperation(payload) {
  return {
    type: actionTypes.CREATE_OPERATION,
    payload
  };
}
export function createOperationSuccess(payload) {
  return {
    type: actionTypes.CREATE_OPERATION_SUCCESS,
    payload
  };
}
export function createOperationFail(payload) {
  return {
    type: actionTypes.CREATE_OPERATION_FAIL,
    payload
  };
}

export function delConfigureStockAttribute(payload) {
  return {
    type: actionTypes.DELETE_ATTR,
    payload
  };
}
export function delConfigureStockAttributeSuccess(payload) {
  return {
    type: actionTypes.DELETE_ATTR_SUCCESS,
    payload
  };
}
export function delConfigureStockAttributeFail(payload) {
  return {
    type: actionTypes.DELETE_ATTR_FAIL,
    payload
  };
}
